import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    changeDetect: PropTypes.string // parent can alter this when it wants to scroll
};

const defaultProps = {
    changeDetect: ''
};

class ScrollToBottom extends React.Component {
    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();
    }
    
    componentDidMount() {
        this.scrollRef.current.scrollIntoView();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.changeDetect !== this.props.changeDetect) {
            this.scrollRef.current.scrollIntoView();
        }
    }
    
    render() {
        return (
            <div ref={this.scrollRef} className="scroll-to-me"/>
        );
    }
};

export default ScrollToBottom;
